/**
 * Google・Apple での本人確認から戻った画面（/oauth/reauth、#189、docs/76 ⑤）。本人確認の窓が開いた小さな別の窓の中で開く。
 *   API の戻り口が引き継ぎ（5分の Cookie）を置いてここへ送る → POST /auth/oauth/reauth/finish → 元の窓へ知らせて（BroadcastChannel）閉じる。
 *   断られた（?oauth_error=）ときも知らせて閉じる。自動で閉じなければ文を出す。
 *   窓が開けず同じ窓で移ってきたとき（戻り先あり）は、その画面へ戻る
 */
import { REAUTH_MSG, oauthErrorText } from "@genbaryoku/contract";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { api, messageOf } from "../api.js";
import { notifyReauth } from "../components/ReauthDialog.jsx";
import { notify } from "../components/Notice.jsx";
import { AuthCard, ErrorText } from "../components/ui.jsx";

export function OAuthReauthPage() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState<{ ok: boolean; text: string } | null>(null);
  // StrictMode（開発）で2回走らないように。引き継ぎは1回きり
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const code = sp.get("oauth_error");
    const close = (ok: boolean, text: string) => {
      setState({ ok, text });
      window.setTimeout(() => window.close(), 300);
    };
    if (code) {
      const text = oauthErrorText(code) || REAUTH_MSG.failed;
      notifyReauth({ ok: false, error: text });
      close(false, text);
      return;
    }
    void api<{ ok: boolean; next: string | null }>("POST", "/auth/oauth/reauth/finish")
      .then((r) => {
        notifyReauth({ ok: true });
        if (r.next) {
          notify({ text: REAUTH_MSG.done });
          nav(r.next, { replace: true });
          return;
        }
        close(true, REAUTH_MSG.done);
      })
      .catch((e: unknown) => {
        const text = messageOf(e);
        notifyReauth({ ok: false, error: text });
        close(false, text);
      });
  }, [sp, nav]);

  return (
    <AuthCard title={state ? (state.ok ? REAUTH_MSG.done : REAUTH_MSG.failed) : REAUTH_MSG.finishing}>
      {state && !state.ok ? <ErrorText>{state.text}</ErrorText> : null}
      {state ? <p className="hint" data-testid="reauth-close">{REAUTH_MSG.closeWindow}</p> : null}
    </AuthCard>
  );
}
